var map = {
	"./config-dev": 28655,
	"./config-dev.ts": 28655,
	"./config-local": 52833,
	"./config-local.ts": 52833,
	"./config-prd": 61277,
	"./config-prd.ts": 61277,
	"./config-stg": 57783,
	"./config-stg.ts": 57783,
	"./config-sub": 74613,
	"./config-sub.ts": 74613,
	"./config-tst": 63731,
	"./config-tst.ts": 63731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48089;